import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'entrar',
        loadComponent: () =>  import('./paginas/entrar/entrar').then(m => m.Entrar)
    },  
    {
        path: 'welcome',
        loadComponent: () =>  import('./paginas/welcome/welcome').then(m => m.Welcome)
    },
    {
        path: 'mapa',
        loadComponent: () =>  import('./paginas/mapa/mapa').then(m => m.Mapa)
    },
    {
    path: '',
    loadComponent: () => import('./@layout/main/main').then(m => m.Main),
    children: [
    {
        path: 'home',
        loadComponent: () =>  import('./paginas/home/home').then(m => m.Home)
    },
    {
        path: 'unidade/:id',
        loadComponent: () => import('./paginas/unidade/unidade').then(m => m.Unidade)
    },
    {
        path: 'evento/:id',
        loadComponent: () => import('./paginas/evento/evento').then(m => m.EventoComponent)
    },
    {
        path: 'explorar',
        loadComponent: () => import('./paginas/explorar/explorar').then(m => m.Explorar)
    },
    {
        path: 'acervo-de-arte/obras',
        loadComponent: () => import('./paginas/acervo-arte/obras/obras').then(m => m.AcervoObras)
    },
    {
        path: 'acervo-de-arte/obra/:codigo',
        loadComponent: () => import('./paginas/acervo-arte/obra/obra').then(m => m.AcervoObra)
    },
    {
        path: 'favoritos',
        loadComponent: () => import('./paginas/em-construcao/em-construcao').then(m => m.EmConstrucao),
        data: { titulo: 'Favoritos', icone: 'pi-heart' }
    },
    {
        path: 'onde-comer',
        loadComponent: () => import('./componentes/catalogo-servicos/catalogo-servicos').then(m => m.CatalogoServicos),
        data: { catalogo: 'restaurantes' }
    },
    {
        path: 'catalogo-servicos',
        loadComponent: () => import('./componentes/catalogo-servicos/catalogo-servicos').then(m => m.CatalogoServicos)
    },
    {
        path: 'pesquisa',
        loadComponent: () => import('./paginas/pesquisa/pesquisa').then(m => m.Pesquisa)
    },
    {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
    }
    ]
    },
    {
        path: '',
        redirectTo: 'welcome',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'welcome'
    }
];
